import { Card, Flex, Form, theme } from 'antd'
import React, { useEffect } from 'react'
import { styled } from 'styled-components'
import { FormConfigurationType } from '~/features/formConfiguration/common'
import { InputDebounced } from '~/features/shared/components'

const { useToken } = theme

const FormWrapper = styled(Form<FormConfigurationType>)`
  .ant-form-item {
    margin-bottom: 8px;
  }
`

type Props = {
  formConfiguration: FormConfigurationType
  onChange: (values: Partial<FormConfigurationType>) => void
}

export const StepDefault: React.FC<Props> = ({
  formConfiguration,
  onChange,
}) => {
  const { token } = useToken()

  const [form] = Form.useForm<FormConfigurationType>()

  useEffect(() => {
    form.setFieldsValue(formConfiguration)
  }, [formConfiguration])

  const handleChange = (values: Partial<FormConfigurationType>) => {
    const valuesUpdated = { ...formConfiguration, ...values }

    onChange({
      title: valuesUpdated.title,
      description: valuesUpdated.description,
    })
  }

  return (
    <>
      <Card
        style={{
          borderTop: `10px solid ${token.colorPrimary}`,
        }}
      >
        <Flex vertical>
          <FormWrapper
            form={form}
            initialValues={formConfiguration}
            layout="vertical"
            onValuesChange={handleChange}
          >
            <Form.Item name="title">
              <InputDebounced
                styleKey="title-2"
                delaySeconds={0}
                variant="borderless"
                placeholder="Title"
              />
            </Form.Item>

            <Form.Item name="description">
              <InputDebounced
                delaySeconds={0}
                variant="borderless"
                placeholder="Description"
              />
            </Form.Item>
          </FormWrapper>
        </Flex>
      </Card>
    </>
  )
}
